import React from 'react'
import Link from '../components/Link'
import { map, take } from 'lodash'
import PageTransition from 'gatsby-plugin-page-transitions'

import { Cell, ResponsiveContainer } from '../components/ResponsiveGrid'
import {Helmet} from 'react-helmet'
import Header from '../components/Header/index'
import CardText from '../components/CardText'
import { Paragraph } from '../components/Contents'
import BlogMenu from '../components/BlogMenu'
import BlogPostExcerpt from '../components/BlogPostExcerpt'

class Blog extends React.Component {

  render () {
    const {
      data
    } = this.props

    return (<PageTransition>
      <div className="Atrakeur-Page">
        <Helmet>
          <meta charSet="utf-8" />
          <title>DIY, Modélisme et Web / Blog</title>
        </Helmet>

        <Header
          contentID="blog_title"
          size="medium" />

        <div className="Atrakeur-Content">
          <BlogMenu />

          { map(data.allContentfulBlogPost.edges, (node, index) => (
            <BlogPostExcerpt post={node.node} inverted={index % 2 == 1} key={node.node.id}/>
          ))}
        </div>
      </div>
    </PageTransition>)
  }
}
export default Blog

export const pageQuery = graphql`
query blogPosts {
  allContentfulBlogPost(sort: { fields: [createdAt], order: DESC}) {
    edges {
      node {
        id
        title
        slug
        category {
          title
          slug
        }
        featured {
          id
          resolutions(width: 2048) {
            ...GatsbyContentfulResolutions
          }
        }
        childContentfulBlogPostContentTextNode {
          childMarkdownRemark {
            excerpt(pruneLength: 300)
          }
        }
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/pages/blog.js